An array representing the candidate's preferences in an ideal position.

This is only available for uploaded candidate profiles and Apply with SEEK candidate profiles.
For candidate applications & purchased profiles this will be an empty list.
